import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Partners from "@/pages/Partners";
import Affiliate from "@/pages/Affiliate";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/affiliate" element={<Affiliate />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "hsl(105 12% 5%)",
            border: "1px solid hsl(105 17% 12%)",
            color: "#fff",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}
